import { LinkItem } from '@occc/ui-design-system';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

import { routeCreator } from '../utils';

export const breadcrumbLinks: LinkItem[] = [
  { to: programManagementRouteCreator.base(), label: 'Program Management' },
  { to: routeCreator.list(), label: 'Product Preferences' },
  { key: routeCreator.create(), label: 'Update Product Preference' },
];
